import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'
import { EventBus } from '@/js/EventBus.js'

export default class Activator extends HObject {
  constructor (hObject) {
    super(hObject.name, hObject.type, hObject.allowRegistration)
    this.init(hObject)
  }

  register () {
    this.registered = true
    let hApp = window.hScene.hApps[this.hAppName]
    this.hAppName = hApp.name
    let meshRoot = BABYLON.Mesh.CreateBox('box', 2.0, window.scene)

    // Registrando los meshes cargados al hObject
    // this.meshes.push(meshRoot)

    meshRoot.position.x = hApp.content.position.x + this.position.x
    meshRoot.position.z = hApp.content.position.z + this.position.z
    meshRoot.position.y = hApp.content.position.y + this.position.y
    meshRoot.rotation.x = Math.PI * this.rotation.x / 180
    meshRoot.rotation.z = Math.PI * this.rotation.z / 180
    meshRoot.rotation.y = Math.PI * this.rotation.y / 180

    meshRoot.name = hApp.name + '.' + this.name
    this.meshRootName = hApp.name + '.' + this.name

    let material = new BABYLON.StandardMaterial('activator', window.scene)
    material.alpha = 0.2
    material.diffuseColor = new BABYLON.Color3(0, 1, 0)
    material.emissiveColor = new BABYLON.Color3(0, 0.8, 0)

    meshRoot.material = material
  }

  getMesh () {
    return window.scene.getMeshByName(this.meshRootName)
  }

  run (indexActivator) {
    // console.log(this.instructions)
    this.instructions.forEach(function (instruction, index, array) {
      switch (instruction.type) {
        case 'register':
          EventBus.$emit('registerHObjectEvent', {indexActivator, instruction})
          break
        case 'run':
          // console.log('RUN !!!!' + instruction.target + ' ' + instruction.value)
          break
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/hobjects/Activator.js